import React from "react";
import { string, object } from "prop-types";

import "./client-manager-section.m.css";

export const ClientManagerSection = ({
  managerData,
  className = "",
  ...props
}) => {
  const {
    title = "Dedicated Client Manager",
    description = "For any queries related to your membership, please reach out to your assigned manager.",
    name = "",
    email = "",
    phone = ""
  } = managerData || {};

  return (
    <div styleName="client-manager-section" className={className} {...props}>
      <div styleName="content-container">
        <div styleName="static-text">
          <div styleName="title-section">
            <h2 styleName="section-title">{title}</h2>
          </div>
          <p styleName="description">{description}</p>
        </div>

        <div styleName="manager-info">
          <div styleName="manager-name">
            <h3 styleName="name">{name}</h3>
          </div>
          <div styleName="contact-details">
            <p styleName="contact-item">{email}</p>
            <p styleName="contact-item">{phone}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

ClientManagerSection.propTypes = {
  managerData: object,
  className: string
};